import React, { useEffect, useState } from "react";
import { Container, Form, Row, Col, Card, Popover, OverlayTrigger, Button, Stack } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { NAMESPACE_REMOTE } from "../../common/translations/TranslationHelper";
import TransferHelper from "./TransferHelper";
import { useLang } from "../../common/hooks/useLang";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faQuestionCircle as farQuestionCircle
} from "@fortawesome/free-regular-svg-icons";

export default function Analyses({standardOrders, standardOrder, handleAnalysesChanged, cachedOrder}) {
  const [analyses, setAnalyses] = useState([]);

  useEffect(() => {
    if (standardOrder !== null) {
      // Copy -> Do not work on the loaded data
      const initialAnalyses = JSON.parse(
        JSON.stringify(standardOrder["PROBEN"])
      );

      // Add additional field for ui selection
      initialAnalyses.forEach((p1) => {
        p1["checked"] = false;
      });

      // Check first analysis by default
      if (initialAnalyses.length > 0) {
        initialAnalyses[0]["checked"] = true;
      }

      // Eventually restore values of previous order
      TransferHelper.presetAnalysesFromRequestData(initialAnalyses, cachedOrder);

      setAnalyses(initialAnalyses);
      handleAnalysesChanged(initialAnalyses);
    }
  }, [standardOrder, cachedOrder, handleAnalysesChanged]);

  const handleAnalysisChanged = (id) => {
    let newState = undefined;
    for (let analysis of analyses) {
      if (analysis["standardauftragProbeId"] === id) {
        newState = !analysis["checked"];
        break;
      }
    }

    const newAnalyses = JSON.parse(JSON.stringify(analyses));

    if (newState === true) {
      // Add
      for (let analysis of newAnalyses) {
        if (analysis["standardauftragProbeId"] === id) {
          analysis["checked"] = true;
          break;
        }
      }
    } else {
      // Remove
      for (let analysis of newAnalyses) {
        if (analysis["standardauftragProbeId"] === id) {
          analysis["checked"] = false;
          break;
        }
      }
    }

    setAnalyses(newAnalyses);
    handleAnalysesChanged(newAnalyses);
  };

  const popover = (headerText, bodyText) => {
    return (
      <Popover id="popover-basic">
        <Popover.Header as="h3">{headerText}</Popover.Header>
        <Popover.Body style={{ whiteSpace: "pre-line" }}>{bodyText}</Popover.Body>
      </Popover>
    );
  };

  const { currentLanguage } = useLang();
  const [standardOrderInfo, setStandardOrderInfo] = useState();
  useEffect(() => {
    if (standardOrder !== null) {
      for (const item of standardOrders) {
        if (item["PARAMETER2"] === standardOrder["standardauftragId"]) {
          setStandardOrderInfo(
            currentLanguage === "en" ?
            item["PARAMETER6"] :
            item["PARAMETER5"]
          );
        }
      }
    }
  }, [standardOrder, standardOrders, currentLanguage]);

  const { t } = useTranslation(NAMESPACE_REMOTE);

  if (standardOrder === null) {
    return null;
  } else {
    return (
      <Container fluid="md" className="pt-3">
        <Form.Group as={Row}>
          <Col xs={12} sm={12}>
            <Stack direction="horizontal" gap={2}>
              <h2 className="h5">{t("TEXT.WSHOP2.CREATE_ORDER.HEADLINE_ANALYSIS_1")}</h2>
              {standardOrderInfo && (
                <OverlayTrigger
                  trigger="click"
                  placement="bottom"
                  rootClose={true}
                  overlay={popover(
                    t("TEXT.WSHOP2.CREATE_ORDER.ANALYSIS_INFORMATION"),
                    standardOrderInfo
                  )}
                >
                  <Button variant="primary" className="text-white py-0">
                    <FontAwesomeIcon icon={farQuestionCircle} />
                  </Button>
                </OverlayTrigger>
              )}
            </Stack>
            <p className="text-muted fs-80">{t("TEXT.WSHOP2.CREATE_ORDER.HEADLINE_ANALYSIS_2")}</p>
          </Col>
        </Form.Group>

        <Form.Group as={Row}>
          <Col xs={12} xl={9}>
            <Row xs={1} sm={2} lg={3} className="g-4">
              {analyses.map((analysis, index) => {
                return (
                  <Col key={"key-col-" + analysis["standardauftragProbeId"]}>
                    <Card className="h-100" onClick={(e) => handleAnalysisChanged(analysis["standardauftragProbeId"])}
                      role="button">
                      <Card.Body className="d-flex flex-column">
                        <Card.Text className="flex-grow-1">
                          {analysis["pruefplanBezeichnung"]}
                        </Card.Text>
                        <Form.Check
                          type="switch"
                          className="text-end"
                          role="button"
                          checked={analysis["checked"]}
                          onChange={(e) => handleAnalysisChanged(analysis["standardauftragProbeId"])
                          }
                        />
                      </Card.Body>
                    </Card>
                  </Col>
                );
              })}
            </Row>
          </Col>
        </Form.Group>
      </Container>
    );
  }
}
